var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 56,
    viewBox: "0 0 54 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2262 36.0002L2.09289 15.0402C1.56969 14.1358 1.32364 13.0977 1.38527 12.0548C1.4469 11.0118 1.8135 10.0099 2.43956 9.1735L6.73289 3.46683C7.22968 2.80445 7.87386 2.26683 8.61442 1.89655C9.35498 1.52627 10.1716 1.3335 10.9996 1.3335H42.9996C43.8275 1.3335 44.6441 1.52627 45.3847 1.89655C46.1253 2.26683 46.7694 2.80445 47.2662 3.46683L51.5329 9.1735C52.1631 10.0072 52.5344 11.0077 52.6008 12.0507C52.6672 13.0938 52.4257 14.1333 51.9062 15.0402L39.7729 36.0002M24.3333 28L8.65332 1.8667M29.6663 28L45.3463 1.8667M16.333 14.6668H37.6663M26.9997 44.0002V38.6668H25.6663M40.333 41.3335C40.333 48.6973 34.3635 54.6668 26.9997 54.6668C19.6359 54.6668 13.6663 48.6973 13.6663 41.3335C13.6663 33.9697 19.6359 28.0002 26.9997 28.0002C34.3635 28.0002 40.333 33.9697 40.333 41.3335Z",
    stroke: "#6D33FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2262 36.0002L2.09289 15.0402C1.56969 14.1358 1.32364 13.0977 1.38527 12.0548C1.4469 11.0118 1.8135 10.0099 2.43956 9.1735L6.73289 3.46683C7.22968 2.80445 7.87386 2.26683 8.61442 1.89655C9.35498 1.52627 10.1716 1.3335 10.9996 1.3335H42.9996C43.8275 1.3335 44.6441 1.52627 45.3847 1.89655C46.1253 2.26683 46.7694 2.80445 47.2662 3.46683L51.5329 9.1735C52.1631 10.0072 52.5344 11.0077 52.6008 12.0507C52.6672 13.0938 52.4257 14.1333 51.9062 15.0402L39.7729 36.0002M24.3333 28L8.65332 1.8667M29.6663 28L45.3463 1.8667M16.333 14.6668H37.6663M26.9997 44.0002V38.6668H25.6663M40.333 41.3335C40.333 48.6973 34.3635 54.6668 26.9997 54.6668C19.6359 54.6668 13.6663 48.6973 13.6663 41.3335C13.6663 33.9697 19.6359 28.0002 26.9997 28.0002C34.3635 28.0002 40.333 33.9697 40.333 41.3335Z",
    stroke: "url(#paint0_linear_49096_5400)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49096_5400",
    x1: -2.02004,
    y1: 12.1886,
    x2: 55.6886,
    y2: 41.7954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.813deaf9f355ab6293a25bedcd2ffbf3.svg";
export { ForwardRef as ReactComponent };